import ClearSelectedAnswer from './clear_selected_answer';
import { getAnswersList } from 'scripts/application/selectors/answers';
import SelectAnswer from './select_answer';

export default class SelectFirstAnswerShown {
  constructor(context) {
    this.context = context;
  }

  run() {
    const { answers } = getAnswersList(this.context.stores);
    if (!answers.length) {
      this.context.executeAction(ClearSelectedAnswer);
      return;
    }

    this.context.executeAction(SelectAnswer, { answer: answers[0] });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/answers/select_first_answer_shown.js